<template>
  <el-card
    class="box-card"
    style="display: flex; justify-content: center;
    height: 90vh;
    align-items: center;"
  >
    <div class="error-box" style="display: flex;">
      <div>
        <img src="" alt="" />
      </div>
      <div>
        <span
          class="error-text"
          style="color:  #5cb9b8;    font-size: 20px;font-weight: 700;"
          >您的权限不足....</span
        >
        <div>
          哎呀!您不能操作此模块
          <!-- <el-button
            @click="handleChooseCompany"
            type="text"
            style="font-size:16px"
            >切换公司</el-button
          > -->
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "Empty",
  methods: {
    handleChooseCompany() {
      this.$router.push({
        path: "/choose_company"
      });
    }
  }
};
</script>
